var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisasai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105,
    height: 41.373,
    viewBox: "0 0 105 41.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 105,
    height: 41.373,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M56.469,13.5A15.206,15.206,0,0,1,58.381,9.59,20.266,20.266,0,0,1,73.023.2a20.672,20.672,0,0,1,6.77,40.772c-8.57,1.538-15.546-1.4-20.832-8.322a4.439,4.439,0,0,1-.28-.475,3.228,3.228,0,0,1,1.214-.12A13.509,13.509,0,0,0,62.137,32a.683.683,0,0,1,.439.251A17.523,17.523,0,0,0,76.75,38.337,17.211,17.211,0,0,0,86.8,34.512a17.03,17.03,0,0,0,6.263-10.305A17.017,17.017,0,0,0,89.639,9.95,16.919,16.919,0,0,0,77.96,3.382a17.126,17.126,0,0,0-13.252,3.87,17.375,17.375,0,0,0-5.474,7.867,1.377,1.377,0,0,1-.307.641c-.456.286-.731-.009-.95-.338a5.457,5.457,0,0,0-1.52-1.819c-.022-.015-.006-.064.014-.1Z",
    transform: "translate(8.425 0)",
    fill: "#d71b00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M20.073,6.46c-1.452,3.73-2.874,7.384-4.3,11.036-1.242,3.191-2.494,6.381-3.716,9.58a.621.621,0,0,1-.718.476c-.887-.026-1.776-.031-2.662,0a.587.587,0,0,1-.675-.456Q4.561,18.188,1.091,9.285C.732,8.361.377,7.436,0,6.462c1.391,0,2.718.008,4.048-.006.3,0,.3.214.365.391q1.824,4.949,3.645,9.9c.641,1.745,1.277,3.49,1.955,5.344.265-.7.5-1.308.724-1.916Q13.2,13.517,15.649,6.858c.084-.228.146-.414.477-.408,1.293.025,2.588.01,3.947.01",
    transform: "translate(0 0.963)",
    fill: "#002c69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M23.794,21.4h.61a3.276,3.276,0,0,1,1.206.04c.365.157.108.706.317,1.032a5.749,5.749,0,0,0,.36.618,3.519,3.519,0,0,0,4.411.167,1.046,1.046,0,0,0-.336-1.83,37.032,37.032,0,0,0-4.037-1.153c-.444-.129-.883-.265-1.315-.422a4.184,4.184,0,0,1-1.7-6.764A5.375,5.375,0,0,1,26.352,11.4a8.938,8.938,0,0,1,5.327.429,4.532,4.532,0,0,1,2.758,4.251c.018.216-.018.338-.287.334q-1.581-.021-3.162,0c-.239,0-.286-.091-.34-.307a1.843,1.843,0,0,0-1.878-1.628,3.782,3.782,0,0,0-1.953.246,1.041,1.041,0,0,0-.753.987c0,.518.418.679.8.791,1.468.43,2.944.826,4.417,1.24.265.075.523.175.785.26,3.82,1.241,3.347,5.912,1.266,7.615A6.577,6.577,0,0,1,29.818,27.1a8.752,8.752,0,0,1-5.182-.761,5.414,5.414,0,0,1-2.756-4.7c-.028-.284.145-.24.306-.24.537,0,1.072,0,1.61,0Z",
    transform: "translate(3.265 1.669)",
    fill: "#002c69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M57.741,25.817a8.434,8.434,0,0,1-7.634.885c-2.563-.8-3.426-2.928-3.618-5.066-.021-.223.069-.237.237-.237,1.129,0,2.257.006,3.386,0,.218,0,.261.087.29.29A2.19,2.19,0,0,0,52.576,23.9a4.405,4.405,0,0,0,1.969-.16,1.721,1.721,0,0,0,.862-.578,1.024,1.024,0,0,0-.356-1.684,17.754,17.754,0,0,0-3.224-.963c-.747-.2-1.5-.394-2.223-.664a4.19,4.19,0,0,1-1.554-6.9,5.561,5.561,0,0,1,3.095-1.6,9.557,9.557,0,0,1,4.814.329,5.719,5.719,0,0,1,1.666.96c.274.053.408.276.57.464A5.877,5.877,0,0,1,59.2,16.033c.018.379-.2.519-.542.526-.1,0-.194,0-.292.006-.511.014-1.022.013-1.531,0a2.739,2.739,0,0,0-.388,0,1.226,1.226,0,0,1-1.551-.975c-.271-.888-1.193-.969-2-1a2.933,2.933,0,0,0-1.5.337.835.835,0,0,0-.533.719c0,.374.279.542.578.668a10.3,10.3,0,0,0,1.483.452,36.146,36.146,0,0,1,3.678,1.049c.353.139.682.329,1.024.49a5.947,5.947,0,0,1,.724.475,4.292,4.292,0,0,1,.5.531,4.474,4.474,0,0,1,.8,2.154,7.243,7.243,0,0,1,.01,1c-.041.29-.1.576-.146.864a5.955,5.955,0,0,1-.748,1.549,2.818,2.818,0,0,1-1.033.939Z",
    transform: "translate(6.938 1.669)",
    fill: "#002c69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M22.081,19.171c0,2.365-.014,4.729.011,7.093,0,.449-.13.55-.553.536-.961-.031-1.922-.021-2.882,0-.309.006-.408-.076-.407-.4q.016-7.233,0-14.463c0-.342.1-.445.438-.437.979.021,1.958.024,2.937,0,.371-.01.465.107.463.468-.016,2.4-.008,4.8-.008,7.2",
    transform: "translate(2.724 1.716)",
    fill: "#002c69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M22.081,8.847c0,.554-.009,1.108,0,1.661.006.238-.071.326-.316.324q-1.6-.012-3.211,0c-.257,0-.306-.111-.3-.334q.01-1.662,0-3.322c0-.234.07-.326.315-.324q1.607.016,3.212,0c.26,0,.307.115.3.336-.009.554,0,1.107,0,1.661Z",
    transform: "translate(2.725 1.022)",
    fill: "#002c69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M57.565,26.857a1.186,1.186,0,0,1-.31-.593c-.018-.034-.036-.08-.016-.1.337-.353.649-.729.988-1.032a1.947,1.947,0,0,1-.571-.072c-.178-.231-.014-.3.17-.356a1.9,1.9,0,0,1,.361-.028c.276-.006.55.006.825-.006a2.636,2.636,0,0,1,.717.056c.34.152.416.5.571.785a8.342,8.342,0,0,0,.483.806,1.15,1.15,0,0,1,.238.6c-.037.269-.233.388-.417.228a1.835,1.835,0,0,0-1.357-.3,3.267,3.267,0,0,0-1.2.079c-.192.074-.29-.288-.484-.076Z",
    transform: "translate(8.542 3.681)",
    fill: "#b51501"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M57.867,25.427c-.194-.006-.171.1-.113.221a1.982,1.982,0,0,1-.557,1,2.034,2.034,0,0,1-.347-.78,2.033,2.033,0,0,1,.8-.968c.084-.04.046-.1.056-.144.211-.923.594-1.841.111-2.793.055-.29.11-.578.167-.868.118-.125-.024-.322.148-.46.2.074.179.323.319.441.071.155.033.341.134.488a7.8,7.8,0,0,1,.488,1.714,1.979,1.979,0,0,1-.23.611,5.96,5.96,0,0,1-.977,1.533Z",
    transform: "translate(8.485 3.08)",
    fill: "#a41302"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M57.83,21.794a.972.972,0,0,1,.379.865,3.947,3.947,0,0,1-.471,2.107c-.231.321-.437.764-.872.933-.033-.07-.068-.141-.1-.213a1.423,1.423,0,0,1,.306-.915,2.329,2.329,0,0,0,.3-.876c.046-.255-.1-.318-.231-.436a7.454,7.454,0,0,0,.694-1.468Z",
    transform: "translate(8.471 3.252)",
    fill: "#981001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M61.9,27.962a4.2,4.2,0,0,1-1.924.175.988.988,0,0,0-.988.134c-.155.148-.233.123-.261-.114-.026-.217-.185-.092-.3-.061a.923.923,0,0,1-.307-.459c-.094-.368.2-.263.353-.262.967.011,1.934-.015,2.9-.007.3-.007.421.218.541.44a.179.179,0,0,1-.018.153",
    transform: "translate(8.672 4.084)",
    fill: "#ce1900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M56.483,11.749c.785.3,1.1,1.029,1.491,1.669a1.105,1.105,0,0,0,.872.61c.2.283.009.554-.023.83-.106.308-.144.636-.24.948a.281.281,0,0,1-.1.109c-.133,0-.174.306-.34.136s-.074-.4-.013-.611a2.411,2.411,0,0,0-.633-1.694c-.254-.257-.178-.749-.567-.907a.964.964,0,0,1-.571-.744.522.522,0,0,1,.129-.345Z",
    transform: "translate(8.411 1.753)",
    fill: "#d21a01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M57.522,26.6c.091-.031.048-.442.275-.1.179.276.2-.1.316-.078.665.117,1.343-.064,2.007.083a.674.674,0,0,1,.437.247c.1.129.287.206.321-.088.254.006.31.147.252.368-.317.315-.734.163-1.1.22-.613.093-1.257-.111-1.848.211-.082.044-.155-.079-.24-.111a2.275,2.275,0,0,1-.416-.754",
    transform: "translate(8.585 3.935)",
    fill: "#bb1600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M57.886,27.275c1.021-.44,2.125-.1,3.166-.346.185-.053.275.08.375.193a.373.373,0,0,1,.063.355c-.031.286-.2.087-.315.092-.983.041-1.964.052-2.947,0-.022,0-.047.085-.071.131a.973.973,0,0,1-.272-.429Z",
    transform: "translate(8.639 4.017)",
    fill: "#c41701"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M57.207,23.09c.2.155.2-.154.344-.147.2.923-.388,1.608-.716,2.372q-.278-.626-.556-1.253l.929-.972",
    transform: "translate(8.399 3.424)",
    fill: "#910f02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M56.379,12.049c.288.563.891.821,1.21,1.448.291.573.493,1.186.776,1.762.014.026-.043.086-.066.131-.2.018-.115.291-.364.382a8.4,8.4,0,0,0-.5-1.593,2.068,2.068,0,0,0-.841-1.218c-.139-.151-.278-.3-.418-.453.067-.153.133-.307.2-.46Z",
    transform: "translate(8.385 1.798)",
    fill: "#cb1902"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M57.153,26.012a1.843,1.843,0,0,1,.557-1c.269-.2.518,0,.794.03-.491.332-.706.924-1.237,1.187-.038-.07-.076-.143-.115-.214Z",
    transform: "translate(8.53 3.719)",
    fill: "#ad1401"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M58.395,16.221q.076-.422.149-.845A18.986,18.986,0,0,1,61.3,9.927,17.285,17.285,0,0,1,76.571,2.735,17.675,17.675,0,0,1,78.834,37.76,17.294,17.294,0,0,1,62.5,32.323a4.813,4.813,0,0,1-.339-.433.356.356,0,0,1,.43-.248,30.276,30.276,0,0,1,3.18.056c.272.054.521-.176.8-.154A15.037,15.037,0,0,1,68.6,32.776a14.205,14.205,0,0,0,8.444,1.749,14.015,14.015,0,0,0,10.164-5.852,13.686,13.686,0,0,0,2.6-6.754,14.216,14.216,0,0,0-1.718-8.557.825.825,0,0,1-.108-.311.974.974,0,0,1,.009-.317c.075-.253-.1-.221-.241-.232a.2.2,0,0,1-.08-.11c.01-.134,0-.257-.154-.314a.451.451,0,0,1-.1-.1c-.156-.428-.245-.908-.813-1a.317.317,0,0,1-.167-.13.413.413,0,0,0-.332-.3,1.306,1.306,0,0,1-.277-.147A13.091,13.091,0,0,0,82.6,7.883a14.4,14.4,0,0,0-5.4-1.726,14.213,14.213,0,0,0-13.5,6.329,14.278,14.278,0,0,0-2.366,8.408c.01.53.248,1.057.026,1.591a.717.717,0,0,1-.755.348c-.165-.016-.332-.008-.5-.013-1-.024-1.11-.149-1.491-1.069a2.461,2.461,0,0,1-.072-2.025,2.871,2.871,0,0,0,.109-1.586c-.1-.637-.151-1.283-.261-1.919Z",
    transform: "translate(8.71 0.404)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M66.176,27.962a2.932,2.932,0,0,1-1.757.123,6.893,6.893,0,0,0-1.917.1c-.269.039-.538-.272-.8.009l-.293-.249c0-.032,0-.064-.006-.1.077-.318.083-.344.507-.307.862.075,1.725.024,2.587.056a2.573,2.573,0,0,0,.976-.132.48.48,0,0,1,.4.067c.137.117.361.174.3.429Z",
    transform: "translate(9.164 4.096)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M38.768,27.162a8.653,8.653,0,0,0,4.918-1.11h0c-.225.783.148.819.664.8.813-.037,1.628-.038,2.44,0,.478.022.644-.08.638-.609-.024-2.516-.02-5.03-.015-7.545l0-1.548a11.786,11.786,0,0,0-.123-1.765,4.387,4.387,0,0,0-3.5-3.884,11.967,11.967,0,0,0-4.565-.172A5.291,5.291,0,0,0,34.3,16.476c-.014.316.069.371.349.368.979-.011,1.959-.023,2.939.006.385.013.544-.077.6-.486a1.976,1.976,0,0,1,1.585-1.771,4.926,4.926,0,0,1,1.811-.107c1.437.155,1.851.564,2.026,1.987.044.355.013.548-.418.5a5.028,5.028,0,0,0-.768-.011l-.174.006a13.337,13.337,0,0,0-5.6,1.118,4.711,4.711,0,0,0-2.53,5.749,4.972,4.972,0,0,0,4.644,3.332m2.436-3.35c1.735-.391,2.434-1.142,2.434-2.565h0c0-.09,0-.179,0-.269,0-.206-.007-.411.007-.616.017-.249-.079-.308-.315-.308a17.08,17.08,0,0,0-2.816.148,4.126,4.126,0,0,0-2.087.8,1.671,1.671,0,0,0-.6,1.63,1.409,1.409,0,0,0,1.086,1.124,4.052,4.052,0,0,0,2.292.053",
    transform: "translate(5.062 1.669)",
    fill: "#002c69",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M56.544,12.843c.315.041,1.044.719.98,1.006a.7.7,0,0,0,.224.675c.232.278.146.629.172.949.194.064.006-.467.324-.2-.036.1-.079.2-.107.3-.067.247.084.215.234.178a.814.814,0,0,1,.091.7,1.79,1.79,0,0,0-.072.61,1.18,1.18,0,0,1-.015.18,4.339,4.339,0,0,0-.087,1.278,9.105,9.105,0,0,0,.1,1.985c.006.093.007.187.006.28a.856.856,0,0,1-.094.442c-.137.137-.2.014-.282-.076a5.123,5.123,0,0,0-.788-2.069.89.89,0,0,1,.076-.634,4.733,4.733,0,0,0,.268-2.734,6.415,6.415,0,0,0-1.03-2.872Z",
    transform: "translate(8.439 1.917)",
    fill: "#c21802"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M55.33,17.278c.04-.511.08-1.024.12-1.534h1.643a2,2,0,0,1-.193,1.742c-.161.306-.319.363-.6.245l-.968-.454Z",
    transform: "translate(8.258 2.35)",
    fill: "#a01101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M57.546,15.342c.321.147.237.548.229.7a4.354,4.354,0,0,1-.4,2.167,2.355,2.355,0,0,0-.171.5c-.148-.151-.3-.3-.444-.451a.519.519,0,0,1,.026-.424,2.494,2.494,0,0,0,.271-1.429c-.018-.14.339-.36-.062-.453-.038-.009.046-.114.109-.151.36.047.482-.131.441-.463Z",
    transform: "translate(8.466 2.29)",
    fill: "#ae1401"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M57.188,15.744a3.044,3.044,0,0,1-.345,2.455c-.224-.155-.448-.313-.671-.468a.5.5,0,0,0,.455-.283,3.344,3.344,0,0,0,.34-1.7h.221Z",
    transform: "translate(8.384 2.35)",
    fill: "#a71301"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M57.827,20.073l.241.11c.209.015.2.187.237.329-.033.223.147.463-.054.675-.364.093-.107-.249-.248-.334-.055.11-.11.221-.164.333q-.005-.555-.011-1.11Z",
    transform: "translate(8.631 2.996)",
    fill: "#b31a08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M59.6,25.377l-.761-.022c-.254-.047-.423-.1-.3-.451a2.084,2.084,0,0,0,.259-1.1,4.257,4.257,0,0,0,.2-1.011,1.2,1.2,0,0,1,.12-.461,5.45,5.45,0,0,0,.355-.673.889.889,0,0,1,.969-.562c.4.017.809,0,1.212,0,.6-.013,1.2,0,1.792-.011.224.025.449.008.673.031a.412.412,0,0,1,.311.167c.049.552-.382.9-.57,1.355-.285.57-.617,1.115-.926,1.671-.283.36-.326.877-.753,1.144a.872.872,0,0,1-.255.048c-.149.007-.3.009-.451.013-.128,0-.254.007-.38,0a3.35,3.35,0,0,1-1.488-.14Z",
    transform: "translate(8.731 3.147)",
    fill: "#002c69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M61,27.471l-.283-.234a.432.432,0,0,0-.228-.34l-.233-.526a1.5,1.5,0,0,1,.036-1.2c.14-.333.274-.368.553-.263.054.174-.041.323-.079.482a1.189,1.189,0,0,0,1.215,1.6,9.743,9.743,0,0,0,1.874-.115,2.332,2.332,0,0,1,1.092.09c.208.144.417.287.336.593a.521.521,0,0,1-.449.171,25.21,25.21,0,0,1-3.32-.066A1.207,1.207,0,0,1,61,27.471Z",
    transform: "translate(8.976 3.709)",
    fill: "#cccdcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M60.918,24.915c-.7.048-.416.671-.585,1.026-.054.115.013.287.023.433a13.582,13.582,0,0,1-.9-1.555l1.572,0c.014.09-.017.131-.111.1",
    transform: "translate(8.874 3.703)",
    fill: "#d3d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M58.912,23.456c.165.017.215.085.151.255a4.754,4.754,0,0,1-.322.915c-.186.291.1.263.169.378l-.886,0a3.515,3.515,0,0,1,.6-1.461.239.239,0,0,1,.291-.091Z",
    transform: "translate(8.66 3.498)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M58.732,23.566a14.444,14.444,0,0,1-.665,1.44l-.331,0c.292-.523.586-1.046.878-1.569a.145.145,0,0,1,.117.125Z",
    transform: "translate(8.617 3.498)",
    fill: "#f2edec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M59.564,21.905a.737.737,0,0,1-.334.555c-.514-.093-.623-.615-.953-.9-.024-.144-.047-.286-.071-.43-.025-.221-.048-.444-.072-.664.5.316.857.8,1.358,1.116a.212.212,0,0,1,.071.326Z",
    transform: "translate(8.676 3.054)",
    fill: "#d7d6d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M58.258,21.419c.144-.109.187.033.251.1.237.263.468.532.7.8a.694.694,0,0,1-.117.436c-.091.16-.057.4-.311.447l-.524-1.785",
    transform: "translate(8.695 3.191)",
    fill: "#cecbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M58.746,23.025c.134-.128.1-.374.311-.447.257.4-.047.691-.215,1l-.223.111-.118-.126a1.323,1.323,0,0,1,.246-.542Z",
    transform: "translate(8.731 3.37)",
    fill: "#f6f7f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M60.886,27.136a34.116,34.116,0,0,0,3.863.1c.144,0,.3.023.4-.122.107-.046.187.011.267.07.1.106.226.2.178.372a.886.886,0,0,1-.786.251c-1-.062-2.007.059-3.006-.088-.094-.014-.322-.059-.318.185l-.44-.454c-.051-.1-.1-.208-.154-.313Z",
    transform: "translate(9.087 4.044)",
    fill: "#eae9e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M58.451,14.466c.36.244.216.641.278.969a4.8,4.8,0,0,1-.155,3.133,1.009,1.009,0,0,0,.039.848c.074.19.162.372.229.563.309.9.353.939,1.345.926.4-.006.847.172,1.181-.216.276.152.247.4.2.652a.338.338,0,0,1-.1.149c-.53-.018-1.063.052-1.592-.011a1.511,1.511,0,0,1-1.439-1.225,1.218,1.218,0,0,0-.363-.663,2.813,2.813,0,0,1,.023-1.518,6.176,6.176,0,0,0,.145-2.612,2.462,2.462,0,0,1,.207-.994Z",
    transform: "translate(8.654 2.159)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M58.254,15.332a2.983,2.983,0,0,1,.078,2.241,3.753,3.753,0,0,0-.183,1.878,1.714,1.714,0,0,1,.382,1.071c-.31.146-.325-.191-.484-.294a8.378,8.378,0,0,1-.1-2.11c.064-.441.024-.89.1-1.33,0-.037,0-.075.006-.113.1-.19,0-.407.082-.6.01-.231.023-.463.034-.694a.4.4,0,0,0,.086-.049Z",
    transform: "translate(8.645 2.288)",
    fill: "#f2f1f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M61.052,22.68a1.315,1.315,0,0,0-.109-.653,16.058,16.058,0,0,1,.31-5.6A14.43,14.43,0,0,1,73.709,5.585,14.219,14.219,0,0,1,84.856,9.153c.27.233.5.508.754.763a.383.383,0,0,1-.274.239,3.8,3.8,0,0,1-1.04-.046,8.6,8.6,0,0,0-3.282.287,2.44,2.44,0,0,0-1.642,1.931c-.138.745-.211,1.523-.3,2.288a1.268,1.268,0,0,1-.168.577.918.918,0,0,0-.117.745,1.752,1.752,0,0,1-.217,1.33c-.114.2-.168.5-.473.465-.277-.028-.355-.294-.446-.515a8.447,8.447,0,0,1-.445-1.7,19.2,19.2,0,0,1-.461-2.5.557.557,0,0,0-.232-.422,2.312,2.312,0,0,1-.4-.715c-.239-.562-.58-.963-1.265-.891a.249.249,0,0,1-.249-.179c-.22-.616-.833-.532-1.261-.586a4.8,4.8,0,0,0-3.816,1.129,1.5,1.5,0,0,0-.449.623A35.755,35.755,0,0,1,67.1,15.6c-.638,1.286-1.353,2.536-2.084,3.77a17.48,17.48,0,0,1-1.253,2.372,2.538,2.538,0,0,1-2.212,1.109c-.11-.006-.222.022-.332.007s-.129-.1-.168-.177Z",
    transform: "translate(9.079 0.821)",
    fill: "#002c69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M65.6,30.407c-.107-.113-.214-.225-.318-.338,0-.179-.024-.378.261-.34.39.292.711.111.969-.184a8.143,8.143,0,0,0,1.551-2.4,1.841,1.841,0,0,1,1.586-1.189,1.252,1.252,0,0,1,1.414.742,4.04,4.04,0,0,1,.4,1.255,2.742,2.742,0,0,0,2.262,2.287,11.194,11.194,0,0,0,3.9-.048,3.063,3.063,0,0,1,1.477.137A3.327,3.327,0,0,0,81,30.28a1.865,1.865,0,0,1,.708-.06,1.813,1.813,0,0,0,1.8-1.119,16.384,16.384,0,0,0,.7-3.628,26.414,26.414,0,0,1,.521-2.92c.244-1.046.288-2.112.482-3.159a10.294,10.294,0,0,1,.56-2.528.645.645,0,0,0,.083-.321,19.818,19.818,0,0,1,.26-2.692,17.535,17.535,0,0,1,.346-1.9c.016-.107.085-.208.013-.315-.13-.12-.433-.085-.375-.371s.348-.072.488-.2c.061-.011.085.015.08.075a.054.054,0,0,0,.037.07.733.733,0,0,1,.293.453,16.564,16.564,0,0,1,1.826,5.07,14.343,14.343,0,0,1-8.132,15.414,14.122,14.122,0,0,1-14.822-1.558c-.09-.063-.184-.12-.276-.179Z",
    transform: "translate(9.743 1.651)",
    fill: "#002c69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M84.889,11.364a.469.469,0,0,1-.018.1c-.133.006-.36-.121-.351.118.007.172.24.075.372.1-.171.369-.218.376-.616.076-.049-.409-.459-.508-.672-.775-.128-.17-.351-.161-.514-.264-.082-.07-.147-.154-.223-.229a4.449,4.449,0,0,0-2.32-.244,3.956,3.956,0,0,1-.881.036,1.889,1.889,0,0,0-1.814,1.28,8.317,8.317,0,0,0-.642,2.771.735.735,0,0,1-.41.725c-.253-.059-.247-.254-.208-.437.2-.948.278-1.918.475-2.86a2.519,2.519,0,0,1,1.183-1.62,4.767,4.767,0,0,1,1.716-.583,11.76,11.76,0,0,1,2.857.031c.115.01.2.029.184-.124.084-.043.169-.083.254-.125l.2.122a.729.729,0,0,1,.317.353l.093.1a2.321,2.321,0,0,1,.884,1.127l.018-.031-.021.03c.131.067.218.155.139.315Z",
    transform: "translate(11.428 1.395)",
    fill: "#002b64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M83.8,10.981l-.884-1.126c.5-.187.6.286.8.533.107.132.059.391.08.593",
    transform: "translate(12.376 1.464)",
    fill: "#f8f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M84.216,11.664a1.088,1.088,0,0,1-.293-.453l.431-.16c-.052.229-.094.421-.138.613",
    transform: "translate(12.525 1.649)",
    fill: "#f8f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M83.828,11.146c-.047-.106-.093-.211-.14-.315.141-.02.306-.071.375.093.023.055-.091.167-.14.253a.3.3,0,0,1-.094-.031",
    transform: "translate(12.49 1.613)",
    fill: "#f8f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M82.881,9.8c-.107-.117-.213-.236-.318-.353.259-.021.352.109.318.353",
    transform: "translate(12.322 1.41)",
    fill: "#f8f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M65.566,27.92l-.21.328-.34-.121-.231-.3c-.121-.3.086-.331.275-.278.371.1.592-.106.824-.323a9.445,9.445,0,0,0,1.5-2.169c.094-.157.175-.324.275-.48a2.779,2.779,0,0,1,3.632-.991.539.539,0,0,1,.31.424,15.375,15.375,0,0,1,.8,2.654.4.4,0,0,1-.047.363c-.386.159-.429-.187-.527-.392-.239-.5-.252-1.063-.459-1.584a1.59,1.59,0,0,0-1.931-1.024,2.664,2.664,0,0,0-1.822,2.028,3.991,3.991,0,0,1-1.491,1.85.432.432,0,0,1-.561.018Z",
    transform: "translate(9.664 3.474)",
    fill: "#00285f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M59.578,22.007c-.187-.465-.711-.563-1.023-.913-.149-.169-.253-.369-.407-.53-.038-.113-.075-.226-.113-.339,0-.147,0-.293,0-.44.285-.008.352.241.451.418a1.594,1.594,0,0,0,1.587.886c.494-.022.992-.036,1.489-.015a.2.2,0,0,1,.183.137.267.267,0,0,1-.053.23,8.136,8.136,0,0,1-1.032,0,.919.919,0,0,0-1.087.565Z",
    transform: "translate(8.662 2.953)",
    fill: "#e6e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M61.59,21.114c-.033.06-.079.178-.1.174-.617-.128-1.24.034-1.856-.037a1.575,1.575,0,0,1-1.209-.849c-.117-.2-.157-.456-.385-.587l-.01-.223c.244-.02.285.228.434.332.779,1.08,1.869.945,2.972.762.009-.037.02-.074.031-.109l.1.125a.29.29,0,0,1,.018.413Z",
    transform: "translate(8.661 2.924)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M58.046,16.6a3.092,3.092,0,0,1-.1,1.329,4.168,4.168,0,0,1,.1-1.329",
    transform: "translate(8.647 2.477)",
    fill: "#ebe1df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M58.117,15.979c.008.2.084.418-.08.6a.925.925,0,0,1,.08-.6",
    transform: "translate(8.66 2.385)",
    fill: "#ebe1df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M63.684,22.884c-.036-.124-.154-.087-.237-.123-.1-.055-.186-.111-.1-.241a.467.467,0,0,1,.224-.067.853.853,0,0,0,.747-.475c.854-1.487,1.631-3.014,2.494-4.495,1.014-1.734,1.927-3.526,2.883-5.292a1.892,1.892,0,0,1,1.363-1.1c.221-.038.452-.428.648.031.029.524-.33.891-.554,1.3q-2.734,5.037-5.512,10.049a.944.944,0,0,1-.33.434c-.541-.032-1.088.2-1.628-.03Z",
    transform: "translate(9.449 1.627)",
    fill: "#00214f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M62.268,24.1c.309-.553.616-1.106.925-1.657.085-.023.215.028.252-.066.123-.309.324-.38.6-.221s.479.346.336.709c-.04.1.018.216.014.326a.726.726,0,0,1-.039.226,4.018,4.018,0,0,1-.231.475,3.281,3.281,0,0,0-.332.57,3.9,3.9,0,0,1-.429.708.483.483,0,0,1-.418.19.443.443,0,0,1-.193-.14c-.175-.368-.573-.64-.486-1.121",
    transform: "translate(9.292 3.295)",
    fill: "#011e46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M63.873,21.6h-.222c-.122.237-.393.075-.554.209l-1.877.006c0-.071,0-.144-.006-.216.143-.3.429-.262.673-.247a2.007,2.007,0,0,0,2.043-1.364c.4-.869,1.019-1.612,1.429-2.479.076-.159.2-.324.432-.232a.771.771,0,0,1,.114.488c.04.4-.223.687-.392,1.012A28.175,28.175,0,0,1,63.873,21.6Z",
    transform: "translate(9.136 2.575)",
    fill: "#00285e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M64.156,23.346c-.154-.272.24-.626-.143-.872-.234-.153-.426-.291-.56.106-.126.379-.267.284-.385-.014.217-.41.434-.818.65-1.229a4.032,4.032,0,0,1,1.548.016.215.215,0,0,1,.049.214c-.182.325-.364.65-.521.99a4.17,4.17,0,0,1-.228.375,3.073,3.073,0,0,1-.278.422.122.122,0,0,1-.136-.007Z",
    transform: "translate(9.413 3.174)",
    fill: "#02204c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M61.179,24.816l.448,0a.141.141,0,0,1,0,.147,1,1,0,0,0-.163,1.241c.275.376.683.4,1.241.22.44-.14.547-.572.879-.786.487.132.7.564,1.007.9.047.1.121.2,0,.3a4.236,4.236,0,0,0-1.623.139A3.239,3.239,0,0,1,61.542,27a.9.9,0,0,1-.81-.785c-.06-.51-.18-1.089.445-1.4Z",
    transform: "translate(9.057 3.703)",
    fill: "#bbbcbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M62.377,23.84q.286.553.573,1.106a1.617,1.617,0,0,1-.6,1.2c-.136.143-.275.251-.484.165a.507.507,0,0,1-.352-.508,1.79,1.79,0,0,1,.206-.842l.656-1.119Z",
    transform: "translate(9.181 3.558)",
    fill: "#a8a9a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M61.208,24.816a1.7,1.7,0,0,0-.322,1.449.686.686,0,0,0,.6.619,2.6,2.6,0,0,0,1.449-.006,2.267,2.267,0,0,1,1.715-.079c.17-.017.267.03.194.223a14.743,14.743,0,0,0-2.692.132,1.413,1.413,0,0,1-1.387-2.241l.11-.1.332,0Z",
    transform: "translate(9.027 3.703)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M61.767,24.814c-.025.275-.032.552-.083.822-.046.238.082.326.254.422.191.107.237-.057.348-.14.387-.282.457-.755.709-1.115.045.036.09.071.133.108a.377.377,0,0,1,.237.345.638.638,0,0,1-.122.275c-.267.208-.316.586-.607.776a.883.883,0,0,1-.134.09,1.086,1.086,0,0,1-.97-.074c-.429-.442-.424-.836.013-1.4,0-.032,0-.063,0-.1l.22-.007Z",
    transform: "translate(9.136 3.702)",
    fill: "#aeaeae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M62.854,21.248c.132-.21.382-.107.554-.209l.109.209Z",
    transform: "translate(9.381 3.14)",
    fill: "#002354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M64.317,27.3a.305.305,0,0,0-.194-.223c-.039-.074-.079-.146-.117-.22.066-.147.207-.2.3-.091.191.215.487.223.686.4.092.037.076-.055.108-.093a.247.247,0,0,1,.134-.062A.721.721,0,0,0,66,26.685c.34-.454.576-.99.911-1.426.511-.667.627-1.651,1.543-2a.91.91,0,0,0,.093-.06,4.514,4.514,0,0,1,3.342.319,2,2,0,0,1,.565,2.142c-.326.079-.286-.186-.346-.363-.142-.424-.121-.924-.548-1.219.008-.187-.049-.283-.259-.347a4.745,4.745,0,0,0-1.857-.2c-.93.088-1.343.8-1.75,1.508a8.842,8.842,0,0,1-1.743,2.479c-.233.2-.452.447-.806.187-.156-.113-.23.006-.249.162-.071-.046-.141-.093-.213-.138-.121-.144-.244-.286-.364-.43Z",
    transform: "translate(9.553 3.433)",
    fill: "#002558"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M61.426,20.787c-.037.061-.072.174-.111.175-.9.039-1.85.346-2.605-.471a.8.8,0,0,1-.255-.467c.038-.415-.372-.694-.333-1.11.3,0,.329.252.39.453.313,1.038.44,1.23,1.8,1.329.372.026.764-.165,1.117.091Z",
    transform: "translate(8.674 2.823)",
    fill: "#f4f4f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M65.777,18.445a16.138,16.138,0,0,0-1.255,1.97c-.225.349-.341.784-.568,1.11a2.036,2.036,0,0,1-1.8,1.145,1.476,1.476,0,0,0-.917.1c-.034-.046-.068-.094-.1-.14-.006-.138-.011-.276-.018-.414a1.54,1.54,0,0,1,.81-.11,1.724,1.724,0,0,0,1.507-.863c.186-.315.525-.5.636-.888a7.826,7.826,0,0,1,.824-1.691c.564-.977,1.073-1.982,1.655-2.951.545-.907.956-1.893,1.516-2.788.338-.54.607-1.1.894-1.663a3.569,3.569,0,0,1,2.584-1.679,9.263,9.263,0,0,1,1.2-.146,11.512,11.512,0,0,1,1.665.269c.3.008.247.311.255.528a.452.452,0,0,1-.309.137c-.831-.192-1.674.049-2.516-.075a1.981,1.981,0,0,0-1.457.569,4.1,4.1,0,0,0-1.168,1.384c-.5.981-1.007,1.962-1.549,2.914a29.277,29.277,0,0,1-1.881,3.283Z",
    transform: "translate(9.121 1.407)",
    fill: "#002c69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M83.364,9.463l.161.267c-.7-.054-1.371-.121-2.047-.152a5.266,5.266,0,0,0-2.7.617,2.391,2.391,0,0,0-1.227,1.822c-.121.852-.3,1.7-.461,2.541-.032.164-.106.319.056.454a1.189,1.189,0,0,1,.094,1.161,11.4,11.4,0,0,0-.456,2.087c-.034.143-.039.292-.083.432-.084.271-.2.548-.514.583s-.408-.257-.533-.479a4.708,4.708,0,0,1-.527-1.832,1.46,1.46,0,0,1,.021-.441c.157-.554-.19-1.018-.278-1.529a.779.779,0,0,1-.031-.154,2.32,2.32,0,0,0-.613-1.8.277.277,0,0,1-.018-.214c.254-.118-.038-.177-.032-.269a.519.519,0,0,1-.01-.226c.053-.182.111-.361.317-.431.341-.023.431.157.451.473a15.868,15.868,0,0,0,.61,3.16,7.584,7.584,0,0,0,.3,1.162c.064.145.093.364.29.362s.211-.23.283-.368a1.616,1.616,0,0,0,.2-1.415.648.648,0,0,1,.033-.534c.462-.638.318-1.407.5-2.1a5.162,5.162,0,0,1,.351-1.607,2.967,2.967,0,0,1,2.523-1.589,19.058,19.058,0,0,1,3.349.017Z",
    transform: "translate(11.068 1.4)",
    fill: "#002b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M74.733,11.793c-.075.147-.147.3-.222.444-.214.075-.183.356-.383.452a.41.41,0,0,1-.225-.5c.255-.49-.11-.716-.352-1a1.477,1.477,0,0,1-.209-.487c-.159-.228-.429-.154-.64-.238-.187-.075-.3-.16-.078-.33h.332c.232.233.5-.075.861.159.617.4.659.983.916,1.506",
    transform: "translate(10.821 1.512)",
    fill: "#002a63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M81.659,9.3c-.149,0-.1-.115-.113-.193-.018-.1.006-.19.125-.179.079.007.111.086.089.165s.052.2-.1.207",
    transform: "translate(12.17 1.332)",
    fill: "#002b64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M65.46,29.695c.684-.02.987-.6,1.417-.98.533-.475.413-1.286.9-1.807.245-.262.408-.6.629-.884a2.307,2.307,0,0,1,1.942-.357c.336.156.878.187.922.569.061.522.4.93.425,1.454a1.165,1.165,0,0,0,.541,1.117c.02.016.038.03.059.045a.9.9,0,0,0,.552.46.723.723,0,0,1,.139.1,2.151,2.151,0,0,0,1.449.444,9.8,9.8,0,0,0,2.579-.152,6.4,6.4,0,0,1,2.528.126,4.6,4.6,0,0,0,2.6-.339,2.005,2.005,0,0,0,1.1-1.514,6.226,6.226,0,0,0,.345-2.6.287.287,0,0,1,.038-.215c.524-.765.344-1.68.532-2.516a18.891,18.891,0,0,0,.383-2.655c.061-.769.372-1.562.459-2.365a10.577,10.577,0,0,0,.4-2.987,1.114,1.114,0,0,1,.116-.48,4.281,4.281,0,0,0,.246-2.067c-.041-.229-.242-.614.243-.7.185.175.37.337.555,0,.471.374-.038.74-.082,1.067-.19,1.376-.339,2.756-.526,4.129-.1.759-.384,1.54-.533,2.319a14.867,14.867,0,0,0-.283,2.34c-.018.572-.29,1.06-.355,1.607-.177,1.5-.539,2.97-.676,4.479a14.1,14.1,0,0,1-.5,2.109c-.016.066-.063.168-.108.176-.455.072-.661.514-1.042.693-.094.045-.165.171-.286.129a2.476,2.476,0,0,0-1.416.022,2.939,2.939,0,0,1-1.837-.064,3.43,3.43,0,0,0-1.9-.022,6.948,6.948,0,0,1-2.564.109,4.773,4.773,0,0,1-2.327-.792,2.655,2.655,0,0,1-.748-1.262,9.881,9.881,0,0,1-.324-1.225,1.305,1.305,0,0,0-1.964-1,1.736,1.736,0,0,0-.925,1,8.267,8.267,0,0,1-1.73,2.582c-.374.382-.739.324-.963-.076Z",
    transform: "translate(9.77 1.699)",
    fill: "#002962"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M82.955,10.542c.176.121.493-.134.579.22a2.227,2.227,0,0,1-.008,1.03q-.938,5.577-1.849,11.157c-.186,1.149-.38,2.3-.576,3.444a.8.8,0,0,1-.349.657,13.842,13.842,0,0,1-2.544.057c-.409-.006-.6-.241-.542-.659.064-.5.154-.986.237-1.479q1.141-6.864,2.269-13.731c.09-.22.06-.477.222-.671a.659.659,0,0,1,.559-.182c.668.062,1.36-.172,2.005.155Z",
    transform: "translate(11.59 1.546)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M84.265,11.706a3.937,3.937,0,0,1,.138-1c.2.27.732.263.64.775-.338.184-.14.507-.087.688a2.941,2.941,0,0,1-.172,1.887,3.559,3.559,0,0,0-.171,1.664c.063.683-.46,1.209-.4,1.9a6.262,6.262,0,0,1-.174,1.412c-.016.108,0,.246-.061.319a2.3,2.3,0,0,0-.262,1.784c.039.648-.452,1.153-.413,1.8a9.144,9.144,0,0,0-.091,1.356.477.477,0,0,1-.076.365c-.514.562-.2,1.261-.341,1.871-.246,1.068-.261,2.265-1.279,3.014a3.449,3.449,0,0,1-1.841.576c-1.048.082-2.086-.3-3.126-.192a14.958,14.958,0,0,1-3.052.19c-.6-.059-1.276-.021-1.668-.653a.342.342,0,0,1,.363-.057,9.158,9.158,0,0,0,3.562.157c.3-.015.587.006.881.016a15.405,15.405,0,0,0,4.238-.14,2.856,2.856,0,0,0,1-1.439,30.935,30.935,0,0,0,.5-3.133,12.045,12.045,0,0,1,.484-2.308,10.611,10.611,0,0,0,.37-2.388,16.851,16.851,0,0,1,.577-3.126,7.748,7.748,0,0,0,.275-1.908c.1-.933.3-1.854.315-2.8a.983.983,0,0,0-.131-.636Z",
    transform: "translate(10.721 1.598)",
    fill: "#00285e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M75.245,16.816a4.944,4.944,0,0,0,.547,1.863c.093.164.11.451.368.416.239-.032.342-.277.387-.491a9.67,9.67,0,0,0,.237-1.455c.039-.755.55-1.431.347-2.219.437-.613.232-1.363.44-2.027.318-1.019.465-2.13,1.565-2.69a.888.888,0,0,1,.409-.151c.815.048,1.627-.222,2.421-.094.456.072,1,.018,1.381.413-.167.174-.383.108-.578.107-.787-.006-1.574,0-2.361.055A2.068,2.068,0,0,0,78.433,12.1a17.763,17.763,0,0,0-.5,2.647c-.29,1.254-.359,2.556-.7,3.805a7.058,7.058,0,0,0-.424,1.316,1.265,1.265,0,0,1-.213.508c-.16.221-.372.407-.65.329a.566.566,0,0,1-.4-.6,1.145,1.145,0,0,0-.254-.714c-.344-.485-.159-1.078-.3-1.609-.049-.192,0-.407-.069-.6-.018-.053.039-.175-.075-.153-.045.008-.084.111-.151.149-.146.018-.183-.076-.2-.192a2.709,2.709,0,0,0,.1-1.452.964.964,0,0,0-.161-.452.575.575,0,0,1,.024-.836c.422-.016.349.346.445.58.078.461.246.9.286,1.37a.656.656,0,0,0,.046.627Z",
    transform: "translate(11.085 1.482)",
    fill: "#002961"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M76.781,18.534c-.02-.733.326-1.4.37-2.131a11.706,11.706,0,0,1,.3-1.95,27.714,27.714,0,0,1,.562-2.906A2.551,2.551,0,0,1,80.1,10.323c.965-.01,1.931,0,2.9,0a.239.239,0,0,1,.111.228c-.655.009-1.31.017-1.965.031-.2,0-.4-.048-.579.092-.113.319-.375.37-.662.348a1.282,1.282,0,0,0-1.388,1.024,5.7,5.7,0,0,0-.377,1.938.433.433,0,0,1-.015.22,6.269,6.269,0,0,0-.38,2.425,13.063,13.063,0,0,0-.5,2.693.96.96,0,0,1-.039.361c-.12.18-.2.456-.5.23a2.127,2.127,0,0,1,.077-1.377Z",
    transform: "translate(11.435 1.54)",
    fill: "#002559"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M81.236,27.488a1.389,1.389,0,0,1-1.168.315,32.694,32.694,0,0,1-3.534-.064,18.583,18.583,0,0,0-2.087.09,5.907,5.907,0,0,1-2.424-.341,2.108,2.108,0,0,1-.555-.555,15.743,15.743,0,0,0-.888-3c.525.006.426.468.546.76.109.267-.011.631.341.793a.369.369,0,0,1,.124.222,1.581,1.581,0,0,0,1.831,1.609c2.261-.02,4.521-.013,6.781-.009.34.082.725-.1,1.032.176Z",
    transform: "translate(10.534 3.572)",
    fill: "#00275b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M76.111,16.86a.25.25,0,0,0,.079.249.991.991,0,0,1,.257.655c.246,1.325.593,2.627.876,3.943.091.556.239,1.1.357,1.655.043.177.091.354.122.533.171.833.367,1.662.526,2.5.1.518-.032.7-.554.717-.776.033-1.553.015-2.33.007-.453,0-.653-.261-.744-.672-.229-1.029-.468-2.055-.654-3.091-.087-.488-.294-.69-.806-.678-1.257.028-2.515.023-3.772,0a.962.962,0,0,0-.971.571c-.294.555-.577,1.116-.907,1.651-.391.563-.659,1.194-.993,1.789a.768.768,0,0,1-.367.274,8.81,8.81,0,0,1-1.891,0c-.339-.174-.208-.418-.076-.639a4.089,4.089,0,0,0,.393-.833c.049-.156.121-.313-.047-.446-.134-.134-.055-.228.057-.316a.779.779,0,0,0,.309-1.007c-.113-.228.059-.38.114-.567.007-.057.013-.115.02-.172,1.25-2.255,2.507-4.507,3.748-6.768.912-1.662,1.8-3.336,2.7-5a.778.778,0,0,1,.213-.623A1.737,1.737,0,0,1,73,10.371a4.319,4.319,0,0,1,1.75.229c.043.164.085.329.129.494a1.733,1.733,0,0,1,.283.932,13.6,13.6,0,0,0,.4,1.6c.151,1,.5,1.958.582,2.97a.509.509,0,0,1-.028.271Z",
    transform: "translate(9.571 1.546)",
    fill: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M71.864,10.757c.048.2-.086.321-.2.451-.224-.114-.246-.117-.276.051-.021.122-.075.182-.171.146-.727-.274-1.064.314-1.308.736-.894,1.539-1.678,3.139-2.552,4.691-.829,1.473-1.688,2.931-2.442,4.449a7.6,7.6,0,0,0-.668,1.257c-.251-.084-.444.267-.707.094-.041-.057-.128-.154-.118-.167a31.576,31.576,0,0,0,1.913-3.132.793.793,0,0,0,.092-.475c.529-1.094,1.157-2.134,1.722-3.208.472-.9,1.006-1.762,1.472-2.663.238-.459.525-.888.752-1.355A2.647,2.647,0,0,1,71.08,10.42a.573.573,0,0,1,.781.336Z",
    transform: "translate(9.466 1.548)",
    fill: "#002354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M66.474,24.742c.079-.09.157-.178.236-.269.175.02.415-.021.457.19s-.211.207-.34.287c-.191.118-.272.332-.441.468-.153.09-.308.021-.46.056.159-.036.323.046.478-.068.257-.1.36.114.21.21-.521.337-.709,1.016-1.326,1.235v.111a.129.129,0,0,1-.11.111c-.361-.091-.591-.478-1.006-.441l-.87-.9c-.2-.077-.344-.188-.248-.434l-.177-.345c.107-.079.214-.161.318-.24a5.276,5.276,0,0,1,.555-.024,10.22,10.22,0,0,0,2.72.049Z",
    transform: "translate(9.384 3.652)",
    fill: "#01214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M66.408,25.055a14.521,14.521,0,0,1-2.862.047c-.134.008-.3,0-.194-.183a3.506,3.506,0,0,0,.2-.536.9.9,0,0,1,.291-.563.524.524,0,0,0,.261-.442c0-.067.007-.132.011-.2a.75.75,0,0,1,.089-.016c.153-.1.153-.29.245-.426a.609.609,0,0,1,.2-.353c.4.109.11.468.241.673-.046.028-.2-.054-.11.111a4.247,4.247,0,0,1-.471,1.26c-.116.2-.285.419.031.606l2.068.02Z",
    transform: "translate(9.45 3.341)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M63.581,24.122c.031.174.109.347-.085.491-.165.123,0,.167.074.228a.338.338,0,0,1-.413-.071l.424-.647",
    transform: "translate(9.426 3.6)",
    fill: "#eaebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M64.04,23.249c.14.28-.036.376-.261.442a.955.955,0,0,1,.261-.442",
    transform: "translate(9.519 3.47)",
    fill: "#eaebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M71.6,10.8a1.224,1.224,0,0,0-1.209,0c-1.047.377-1.214,1.293-1.722,2.025a27.589,27.589,0,0,0-1.357,2.432,25.642,25.642,0,0,0-1.687,3.15c-.082.211-.145.479-.459.49v-.555a.75.75,0,0,1,.182-.569c.671-.754.8-1.822,1.507-2.561a2.911,2.911,0,0,0,.347-.733,19.911,19.911,0,0,1,1.447-2.663c.757-1.124,1.616-2,3.231-1.7.542.1,1.218-.049,1.835.011-.1.241.086.175.206.234.217.109.573-.123.668.271-.854-.009-1.71-.02-2.565-.023a.426.426,0,0,0-.422.184Z",
    transform: "translate(9.726 1.502)",
    fill: "#00275d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M64.718,23.191c-.26-.161.021-.515-.242-.673a4.229,4.229,0,0,1,.562-1.024,1.212,1.212,0,0,0,.08.669c.18.406-.109.744-.4,1.029",
    transform: "translate(9.623 3.208)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M64.337,22.691c.007.192-.028.362-.245.426a.9.9,0,0,1,.245-.426",
    transform: "translate(9.566 3.386)",
    fill: "#eaebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M63.324,25.239c.083.145.165.288.248.434a1.581,1.581,0,0,1-1.631,1,.785.785,0,0,1-.8-.693c-.041-.387-.239-.925.419-1.078-.055.445-.456.888,0,1.333.333.167.667.328,1,0,.369-.133.473-.493.667-.778.032-.071.064-.145.1-.217Z",
    transform: "translate(9.117 3.716)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M63.037,25.385a.73.73,0,0,1-.668.777c.317-.179.265-.671.668-.777",
    transform: "translate(9.309 3.789)",
    fill: "#b3b3b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M62.5,26.061a.644.644,0,0,1-1,0c.332,0,.665.242,1,0",
    transform: "translate(9.179 3.889)",
    fill: "#b3b3b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M66.087,25.7c0-.452.292-.619.678-.7-.032-.22-.318-.046-.368-.236a10.463,10.463,0,0,1,.9-1.64c.372-.017.549-.436.944-.434.8,0,1.573-.175,2.386-.156a2.106,2.106,0,0,1,1.93,1.343,5,5,0,0,1,.545,1.772c.152.908.472,1.177,1.386,1.245a7.458,7.458,0,0,0,2.571-.193,5.838,5.838,0,0,1,2.35.223,7.761,7.761,0,0,0,1.871-.1.851.851,0,0,0,.779-.808c.049-.33.061-.756.568-.788a.659.659,0,0,1,.285.788,1.864,1.864,0,0,1-1.7,1.6.3.3,0,0,0-.142.079H74.079A2.328,2.328,0,0,1,72.3,25.922V25.7a2.482,2.482,0,0,0-.386-1.712,1.535,1.535,0,0,0-1.3-.721c-.569-.034-1.142-.008-1.712-.007a2.014,2.014,0,0,0-1.465,1.2c-.031.106-.013.249-.077.315-.6.608-.826,1.465-1.4,2.092-.27.3-.537.633-.991.275.452-.337.6-.961,1.134-1.211.253-.118.187-.177-.024-.231Z",
    transform: "translate(9.698 3.363)",
    fill: "#002353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M64.881,26.751l.111-.111c.124.088.111.194-.01.247-.1.044-.088-.072-.1-.136Z",
    transform: "translate(9.683 3.976)",
    fill: "#002353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M74.716,16.765Q74.1,13.881,73.479,11c.315.261.694.485.375,1-.056.093.068.3.114.471.128-.153-.048-.608.4-.364v.222c-.074.075-.009.147,0,.222v.222a1.115,1.115,0,0,0,.169.675c.1.2.247.422.053.657-.16.383.149.655.213.969.107.54.349,1.154-.084,1.692Z",
    transform: "translate(10.967 1.641)",
    fill: "#01285d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M74.494,13.874a1.268,1.268,0,0,0-.267-.765.351.351,0,0,1,.045-.567,1.86,1.86,0,0,1,.665,1.886c-.16-.176-.17-.47-.444-.555Z",
    transform: "translate(11.06 1.872)",
    fill: "#002a63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M74.945,15.626c.161-.5-.259-.948-.111-1.443.182.5.524.971.333,1.554a.286.286,0,0,1-.222-.111Z",
    transform: "translate(11.164 2.117)",
    fill: "#002a63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M74.926,15.44a.229.229,0,0,1,.222.111V16c-.375-.064-.067-.4-.222-.555",
    transform: "translate(11.183 2.304)",
    fill: "#01285d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M74.261,12.379c-.114-.075-.114-.147,0-.222.033.113.26-.145.225.123-.024.186-.117.14-.225.1",
    transform: "translate(11.071 1.814)",
    fill: "#002a63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M71.352,26.544a.848.848,0,0,1,.555.555.482.482,0,0,1-.555-.555",
    transform: "translate(10.649 3.962)",
    fill: "#00285f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M82.324,26.977c.1.194-.68.054-.156.411-.454.152-.141.65-.425.911a1.894,1.894,0,0,1-1.027.464,11.652,11.652,0,0,1-3.426-.245,4.945,4.945,0,0,0-1.334.254,14.178,14.178,0,0,1-2.026-.021A1.251,1.251,0,0,1,72.672,27.6c-.021-.183-.054-.363-.068-.546A4.827,4.827,0,0,0,71.6,24.827c-.06-.091-.131-.231-.209-.241a5.346,5.346,0,0,0-1.958-.182,1.458,1.458,0,0,1-.908.063c-.307-.117-.511.116-.76.226-.331.146-.344.117-.375.437A.867.867,0,0,1,67,24.847c.386-.731.778-1.46,1.154-2.2a.421.421,0,0,1,.444-.236c1.553.006,3.105.011,4.658,0,.317,0,.388.125.444.408.233,1.2.513,2.379.742,3.575.066.339.184.461.537.448q1.219-.041,2.439,0c.361.011.441-.084.361-.434-.2-.878-.368-1.764-.549-2.647a3.628,3.628,0,0,0,1.27-2.354c.251-1.027.228-2.092.5-3.089.259-.955.185-1.948.467-2.866a7.1,7.1,0,0,0,.3-1.826,4.611,4.611,0,0,1,.578-1.886,1.392,1.392,0,0,1,1.58-.692c.017.006.006.06-.015.1-.149,1.542-.469,3.057-.715,4.583q-.867,5.378-1.786,10.745c-.061.352.067.364.329.365.868,0,1.734.017,2.6.026a.072.072,0,0,1,.025.076c-.009.025-.016.038-.025.038Z",
    transform: "translate(9.999 1.641)",
    fill: "#00214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M80.536,26.891v-.115a5.71,5.71,0,0,0,.415-1.919c.736-4.337,1.44-8.68,2.157-13.022a1.447,1.447,0,0,1,.092-.259c.22.021.292.111.294.36a12.539,12.539,0,0,1-.136,1.635c-.123.987-.253,1.972-.382,2.958a1.5,1.5,0,0,1-.083.429A12.643,12.643,0,0,0,82.33,19.8,15.159,15.159,0,0,0,82.1,22c-.029.469-.439.8-.416,1.268a8.343,8.343,0,0,1-.267,1.927,12.613,12.613,0,0,1-.44,2.643,2.892,2.892,0,0,1-.992,1.5h-1c.068-.149.2-.186.346-.23a1.906,1.906,0,0,0,1.439-1.735c.009-.188-.329-.23-.232-.476Z",
    transform: "translate(11.788 1.728)",
    fill: "#012557"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M80.582,11.2c-.244-.014-.463.11-.716.087a.743.743,0,0,0-.71.53,3.672,3.672,0,0,0-.562,2.132c.145.817-.444,1.435-.406,2.194.052,1.016-.5,1.961-.463,2.932a20.212,20.212,0,0,1-.534,3.09,1.717,1.717,0,0,1-1.28,1.654c-.026-.151-.159-.277-.1-.446-.046-.367.145-.573.4-.833a3.943,3.943,0,0,0,.87-1.926,3.6,3.6,0,0,0,.163-1.011v-.333a17.462,17.462,0,0,0,.444-2.421.365.365,0,0,1,.111-.241c0-.546,0-1.089,0-1.635a.55.55,0,0,1,.152-.454.6.6,0,0,0,.182-.552,5.627,5.627,0,0,1,.361-2.012,1.4,1.4,0,0,1,1.568-1.1,1.369,1.369,0,0,0,.636-.217.9.9,0,0,1-.107.569",
    transform: "translate(11.312 1.586)",
    fill: "#002354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M75.634,20.934c-.4-1.531-.736-3.078-1.009-4.636.055-.153.111-.306.179-.493a4.722,4.722,0,0,1,.382,2.047c.039.236.01.455.24.63a.678.678,0,0,1,.23.7.425.425,0,0,0,.291.546c.144.066.375-.094.486-.284a2.444,2.444,0,0,0,.225-.671,2.153,2.153,0,0,1,.423-1.056v1.441a.644.644,0,0,1,.068.729c-.151.336-.293.677-.473,1-.29.517-.686.53-1.04.049Z",
    transform: "translate(11.138 2.359)",
    fill: "#01285d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M75.5,20.542c.08.02.12-.244.218-.045.134.27.514.37.6.125.225-.611.754-1.127.624-1.856a.693.693,0,0,0,.333-.332c.293.37.064.8-.038,1.1-.269.783-.342,1.722-1.2,2.181-.233.125.186.454-.19.493a9,9,0,0,1-.347-1.663",
    transform: "translate(11.269 2.751)",
    fill: "#002354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M77.614,15.825a22.831,22.831,0,0,1-.346,2.294.518.518,0,0,1-.209.37c-.219-.421.134-.765.155-1.157a9.086,9.086,0,0,0,.188-1.3c-.013-.132.092-.19.211-.207Z",
    transform: "translate(11.49 2.362)",
    fill: "#002354"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M71.352,25.481c.26.008.269.248.3.4.139.656.664.877,1.183,1.116.129.059.294.067.294.264a1.693,1.693,0,0,1-1.777-1.776",
    transform: "translate(10.649 3.803)",
    fill: "#002558"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M69.668,18.746a1.137,1.137,0,0,1,.052-.215c.632-1.162,1.266-2.323,1.964-3.6.17.752.318,1.393.459,2.038.1.467.175.941.3,1.4.079.292.043.393-.285.384-.81-.02-1.622-.007-2.489-.007Z",
    transform: "translate(10.398 2.228)",
    fill: "#01214e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M64.262,24.932c-.336.055-.554-.016-.3-.379.326-.46.378-1.046.736-1.485.206,0,.376.014.238.3a4.631,4.631,0,0,1-.548,1.164.5.5,0,0,0-.13.4",
    transform: "translate(9.53 3.443)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M66.1,25.277a.8.8,0,0,1-.758.041l.758-.041",
    transform: "translate(9.753 3.772)",
    fill: "#002353"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisasai);
export default __webpack_public_path__ + "static/media/visasai.8e0c3f9a1af89b251aca1fc977da01d4.svg";
export { ForwardRef as ReactComponent };